<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content pd-40px">
      <section class="has-text-centered pdb-40px">
        <p class="is-size-3 has-text-weight-bold">
          {{ $t('dcf.calculette.title', { libelleLigne: libelleLigne}) }}
        </p>
        <p class="has-text-default">
          {{ $t('dcf.calculette.sousTitle') }}
        </p>
      </section>
      <div class="columns is-multiline">
        <div class="column is-12"
             v-for="(ligne, index) in lignesForCalcul"
             :key="index">
          <div class="columns is-vcentered">
            <div class="column is-1 pdr-0">
              <b-checkbox v-model="ligne.selected" class="mgt-5px mgr-0">
              </b-checkbox>
            </div>
            <div class="column is-6 mgb-0 pdl-0">
              <p class="has-text-default ellipsis">
                {{ ligne.libelle }}
              </p>
            </div>
            <b-field class="column is-4 is-offset-1">
              <input-currency v-model="ligne.totalHtAvecLigneRemise"
                              symbole=' €'>
              </input-currency>
            </b-field>
          </div>
        </div>
        <div class="column is-12">
          <b-field :label="$t('dcf.calculette.pourcentage')">
            <div class="columns">
              <b-field class="column is-7 has-text-right">
                <input-currency v-model="pourcentage" expanded
                                symbole=' %'>
                </input-currency>
              </b-field>
              <div class="column is-4 is-offset-1">
                <input-currency v-model="prixUnitaireCalculer" disabled
                                symbole=' €'>
                </input-currency>
              </div>
            </div>
          </b-field>
        </div>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="changePrixUnitaireLigne">
              {{ $t('general.button.apply') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import inputCurrency from '@/components/general/inputCurrency';
import messageSuccess from '@/services/general/messageSucces';
import calculArrondi from '@/services/calcul/calculArrondi';

export default {
  props: {
    lignesCommande: {
      type: Array,
      required: true,
    },
    indexLigne: {
      type: Number,
      required: true,
    },
    libelleLigne: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      lignesForCalcul: [],
      pourcentage: 0,
    };
  },
  components: {
    inputCurrency,
  },
  computed: {
    prixUnitaireCalculer() {
      const prix = 0;
      const lignesSelected = this.lignesForCalcul
        .filter((ligne) => { return ligne.selected; })
        .map((ligne) => { return ligne.totalHtAvecLigneRemise; });
      if (lignesSelected.length === 0) return prix;
      const montantTotal = lignesSelected
        .reduce((montantTotal, totalHtAvecLigneRemise) => montantTotal + totalHtAvecLigneRemise);
      return calculArrondi((montantTotal * this.pourcentage) / 100, 5);
    },
  },
  methods: {
    changePrixUnitaireLigne() {
      this.lignesCommande[this.indexLigne].prixUnitaire = this.prixUnitaireCalculer;
      this.$parent.close();
      messageSuccess(this.$i18n.t('dcf.calculette.messages.success.editPrixUnitaire'));
      this.$emit('calcul');
    },
  },
  mounted() {
    this.lignesForCalcul = cloneDeep(this.lignesCommande);
    this.lignesForCalcul.splice(this.indexLigne, 1)
      .map((ligne) => {
        return {
          selected: false,
          libelle: ligne.libelle,
          totalHtAvecLigneRemise: ligne.totalHtAvecLigneRemise,
        };
      });
  },
};
</script>
